<template>
  <v-toolbar :color="color" style="border-radius:4px; max-height: 40px !important;" dense dark class="px-2 widget-toolbar">
    <v-toolbar-title class="ma-0 pa-0">
      <v-icon medium left :color="titleColor">{{icon}}</v-icon>
      <span v-bind:style="{color: titleColor}" class="display-1 font-weight-regular">{{title}}</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <slot name="actions"></slot>
  </v-toolbar>
</template>
<script>
export default {
  name: "WidgetHeader",
  props: {
    color: {
      type: String,
      default: "primary"
    },
    title: {
      type: String,
      required: true
    },
    titleColor: {
      type: String,
      default: "white"
    },
    icon: {
      type: String,
      default: "mdi-format-list-bulleted"
    }
  }
};
</script>
<style>
.widget-toolbar .v-toolbar__content {
  padding: 0px !important;
  max-height: 40px !important;
}
</style>